export type StudyPace = 'relaxed' | 'standard' | 'intensive';

export interface StudyPlan {
  enrollmentDate: string; // ISO Date string
  targetGraduationDate?: string; // ISO Date string

  // The chosen velocity profile
  pace: StudyPace;
  hoursPerWeek: number; // e.g. 10, 15, 25

  // Specific module overrides (key: moduleId, value: targetWeeks)
  // If value is null, pacing is explicitly turned off for this module.
  moduleAdjustments: Record<string, number | null>;
}

export const PACE_CONFIG: Record<StudyPace, { label: string; hours: number; weeksPerModule: number }> = {
  relaxed: { label: 'Relaxed', hours: 10, weeksPerModule: 12 },
  standard: { label: 'Standard', hours: 15, weeksPerModule: 8 },
  intensive: { label: 'Intensive', hours: 25, weeksPerModule: 4 },
};
